import { render, staticRenderFns } from "./float-zixunjianyi-jianyi.vue?vue&type=template&id=59c8b3cb&"
import script from "./float-zixunjianyi-jianyi.vue?vue&type=script&lang=js&"
export * from "./float-zixunjianyi-jianyi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports